import {RedocStandalone} from "redoc";
import React from "react";

export const Uvod = ()=>  {

  return <div className={'markdown redoc-wp'}>
    <RedocStandalone
      definitionUrl={`/spec/homepage.yaml`}
      router="history"
      options={{
        scrollYOffset: 65,
        layout: 'stacked',
        showExtensions: false,
        hideDownloadButtons: true,
        jsonSamplesExpandLevel: Infinity,
        schemasExpansionLevel: Infinity,
      }}
    />
  </div>
}